import Vue from 'vue'
import moment from 'moment'

// String filters
Vue.filter('capitalize', function (string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
})

Vue.filter('L', date => {
  return moment(date).format('L')
})

// da => LL : 'D MMMM YYYY' 9. august 2017
Vue.filter('LL', date => {
  return moment(date).format('LL')
})

// da => LT : 'HH:mm', en => LT : 'AM PM'
Vue.filter('LT', date => {
  return moment(date).format('LT')
})

Vue.filter('dayAndDate', function (date) {
  return moment(date).format('dddd, LL')
})

// Date filters
Vue.filter('isMonth', function (date) {
  return moment(date).format('MMMM')
})

Vue.filter('ddd', date => {
  return moment(date).format('ddd')
})

// Moment filters old
Vue.filter('timeStamp', function (value) {
  return moment(value).format('LT')
})

Vue.filter('dddd', function (value) {
  return moment(value).format('dddd')
})

Vue.filter('D', function (date) {
  return moment(date).format('D')
})

Vue.filter('dateNoYear', function (date) {
  return moment(date).format('dddd, LL')
})

Vue.filter('dateOfMonth', function (value) {
  return moment(value).format('dddd D. MMMM - YYYY')
})

Vue.filter('date', function (date) {
  return moment(date).format('D. MMMM YYYY')
})

Vue.filter('dayOfWeek', function (date, num) {
  return moment(date).isoWeekday(num)
})

Vue.filter('month', function (date) {
  return moment(date).format('M')
})

Vue.filter('isMonthShort', function (date) {
  return moment(date).format('MMM')
})

Vue.filter('isYear', function (date) {
  return moment(date).format('YYYY')
})

// TIME FROM NOW - CALCULATES AND SHOW NICELESS M = A MOMENT

Vue.filter('timeFromNow', function (m) {
  if (m !== null) {
    return 'sidst set ' + moment(m).fromNow()
  } else {
    return 'aldrig været logget ind'
  }
})

Vue.filter('fromNow', function (m) {
  if (m !== null) {
    return moment(m).fromNow()
  }
})

// SET TIME ON EVENT
Vue.filter('timeDisplay', {
  // model -> view
  // formats the value when updating the input element
  read: function (val) {
    return moment(val).format('LT')
  },

  // view -> model
  // formats the value when writing to the data.
  write: function (val, oldval, eventDate) {
    // Get input value
    var momentObj = moment(val, ['h:mm A']) // could be am or pm
    var number = moment(val, 'LT') // check if number
    var hours = moment(momentObj).format('HH')
    var minutes = Math.round(moment(number).format('mm') / 5) * 5

    // Set value on original date
    var _newDate = moment(eventDate).set({'hour': hours, 'minute': minutes})

    // If not a number then return original date
    return isNaN(number) ? eventDate : _newDate
  }
})



// WEBPACK FOOTER //
// ./src/filters/filters.js